<div class="loader">
    <mat-progress-spinner></mat-progress-spinner>
    <p> {{message}} </p>
  </div>